import { useTranslation } from "react-i18next";

const ValueText = ({ value, className = "" }) => {
  const text =
    value === null || value === undefined || value === "" ? "" : String(value);

  return (
    <span
      className={`
        block w-full min-w-0
        text-sm text-gray-700 select-none
        dark:!text-white
        break-words
        ${className}
      `}
      title={text}
    >
      {text || "-"}
    </span>
  );
};

/**
 * ✅ Mobil: label/value yan yana (2 kolon)
 * ✅ md+: senin eski 12 kolon sistemin (label 4, value 8)
 */
const Row = ({ label, children }) => (
  <div
    className="
      grid
      grid-cols-[minmax(110px,160px)_1fr]
      gap-x-3 gap-y-1
      items-start
      min-w-0

      md:grid-cols-12 md:gap-2
    "
  >
    <div
      className="
        font-medium text-sm
        text-gray-800 dark:text-gray-100
        whitespace-nowrap truncate
        min-w-0

        md:col-span-4
        md:whitespace-normal md:truncate-none
        md:break-words md:leading-snug
      "
      title={label}
    >
      {label}
    </div>

    <div className="min-w-0 md:col-span-8">{children}</div>
  </div>
);

const LicenceForm = ({ data }) => {
  const { t } = useTranslation();

  const formatLicenseNo = (value) =>
    value?.replace(/\s+/g, "").match(/.{1,4}/g)?.join(" ") || "";

  const statusLabel =
    {
      1: "ACTIVE",
      2: "IN-ACTIVE",
      3: "BLOCKED",
      5: "PASSIVE",
    }[data?.status] || "-";

  const typeLabel =
    data?.licenseType === "B"
      ? "PAID"
      : data?.licenseType === "F"
      ? "FREE"
      : data?.licenseType === ""
      ? ""
      : "-";

  return (
    <div
      className="
        px-4
        text-gray-800 dark:text-gray-200
        transition-colors

        /* ✅ Mobil: tek kolon ama satırlar kompakt */
        grid grid-cols-1 gap-3 py-3

        /* ✅ md+: 3 kolon görünümün korunsun */
        md:grid-cols-3 md:gap-4 md:py-0
      "
    >
      {/* 1. Kolon */}
      <div className="space-y-2 md:mt-4">
        <Row label={t("Licence")}>
          <ValueText value={formatLicenseNo(data?.licenseNo || "")} />
        </Row>

        <Row label={t("Owner")}>
          <ValueText value={data?.owner || ""} />
        </Row>

        {/* Eğer Type’ı da burada göstermek istiyorsan (ekranda vardıysa) */}
        {/* <Row label={t("Type")}>
          <ValueText value={typeLabel} />
        </Row> */}
      </div>

      {/* 2. Kolon */}
      <div className="space-y-2 md:mt-4">
        <Row label={t("Product")}>
          <ValueText value={data?.productName || ""} />
        </Row>

        <Row label={t("Pack")}>
          <ValueText value={data?.packName || ""} />
        </Row>

      </div>

      {/* 3. Kolon */}
      <div className="space-y-2 md:mt-4">
        <Row label={t("Status")}>
          <ValueText value={statusLabel} />
        </Row>

        <Row label={t("Version")}>
          <ValueText value={data?.currentVersion || ""} />
        </Row>
      </div>
    </div>
  );
};

export default LicenceForm;
